import { render, staticRenderFns } from "./AsideLogoDark.vue?vue&type=template&id=7da3f4f5&scoped=true&"
import script from "./AsideLogoDark.vue?vue&type=script&lang=js&"
export * from "./AsideLogoDark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da3f4f5",
  null
  
)

export default component.exports